const state = {
  dialog_abrir_cotacao: false,
  dialog_ver_cotacao: false,
  produtos_selecionados_carrinho: [],
  produtos_selecionados_cotacao_pedido: [],
  produtos_cotacao_pedido: [],
  cotacoes_id_pedido: [],
  resetar_produtos_selecionados_carrinho: 0,
  atualizar_carrinho_compras: 0
}

const getters = {
  GET_PRODUTOS_SELECIONADOS_CARRINHO(state) {
    return state.produtos_selecionados_carrinho;
  },
  GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO(state) {
    return state.produtos_selecionados_cotacao_pedido;
  },
  GET_PRODUTOS_COTACAO_PEDIDO(state) {
    return state.produtos_cotacao_pedido;
  },
  GET_COTACOES_ID_PEDIDO(state) {
    return state.cotacoes_id_pedido;
  },
  GET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO(state) {
    return state.resetar_produtos_selecionados_carrinho;
  },
  GET_DIALOG_ABRIR_COTACAO(state) {
    return state.dialog_abrir_cotacao;
  },
  GET_DIALOG_VER_COTACAO(state) {
    return state.dialog_ver_cotacao;
  },
  GET_ATUALIZAR_CARRINHO_COMPRAS(state) {
    return state.atualizar_carrinho_compras;
  },
}

const mutations = {
  SET_PRODUTOS_SELECIONADOS_CARRINHO(state, valor) {
    state.produtos_selecionados_carrinho = valor;
  },
  SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO(state, valor) {
    state.produtos_selecionados_cotacao_pedido = valor;
  },
  SET_PRODUTOS_COTACAO_PEDIDO(state, valor) {
    state.produtos_cotacao_pedido = valor;
  },
  SET_COTACOES_ID_PEDIDO(state, valor) {
    state.cotacoes_id_pedido = valor;
  },
  SET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO(state) {
    state.resetar_produtos_selecionados_carrinho++;
  },
  SET_DIALOG_ABRIR_COTACAO(state, valor) {
    state.dialog_abrir_cotacao = valor;
  },
  SET_DIALOG_VER_COTACAO(state, valor) {
    state.dialog_ver_cotacao = valor;
  },
  SET_ATUALIZAR_CARRINHO_COMPRAS(state) {
    state.atualizar_carrinho_compras++;
  },
}

const actions = {
}

export default { namespaced: true, state, mutations, getters, actions }
